import { Link } from "react-router-dom";
import WebLayout from "../../../layout/WebLayout";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ProductAction from "../../../stores/actions/ProductAction";
import { RootState } from "../../../stores";
import UploadCSVPoProductModel from "../../../components/UploadCSVPoProductModel";
import StatusSwitch from "../../../components/StatusSwitch";
import UpdateProductImage from "../../../components/UpdateProductImage";
import ProductEcomStatus from "../../../components/ProductEcomStatus";
import BuyerListModel from "../../../components/BuyerListModel";
import UploadDDCProductModel from "../../../components/UploadDDCProductModel";
import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../../utils/Constants";
import { getCookie } from "../../../utils/CookieAction";

function ProductList() {
  const targetRef = useRef<any>();

  const dispatch = useDispatch<any>();
  const { profileDetails } = useSelector((state: RootState) => state.auth);
  const { productList, currentPage, lastPage, totalData, from, to } =
    useSelector((state: RootState) => state.product);
  const { downloadproductList } = useSelector(
    (state: RootState) => state.product
  );
  const [search, setSearch] = useState<any>();
  const [limit, setLimit] = useState<any>(10);
  const [page, setPage] = useState<number>(1);
  const [poModal, setPoModal] = useState<boolean>(false);
  const [DDCProductModal, setDDCProductModal] = useState<boolean>(false);
  const [galleryModel, setGallerModal] = useState<boolean>(false);
  const [proId, setProId] = useState<any>(null);
  const [productId, setProductId] = useState<any>(null);
  const [buyerModel, setBuyerModel] = useState<boolean>(false);
  const maxPagesToShow = 5; // Maximum number of page links to show
  const pagination = [];
  const [pdfLoader, setPdfLoader] = useState<boolean>(false);

  const startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
  const endPage = Math.min(startPage + maxPagesToShow - 1, lastPage);

  for (let i = startPage; i <= endPage; i++) {
    pagination.push(i);
  }

  const getProductList = useCallback(async () => {
    await dispatch(
      ProductAction.getProduct({
        limit: limit,
        search: search,
        page: page,
      })
    );
  }, [dispatch, search, limit, page]);

  const downloadDDCProductList = async () => {
    setPdfLoader(true);
    try {
      const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

      const response = await fetch(BASE_URL + "account/pdfGenerate", {
        headers: {
          Authorization: "Bearer " + JSON.parse(token),
          Accept: "application/json",
        },
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link: any = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "product_list.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setPdfLoader(false);
    } catch (error) {
      setPdfLoader(false);
      console.error("Error downloading PDF: ", error);
    }
  };

  useEffect(() => {
    getProductList();
  }, [getProductList, search, limit, page]);

  const openModel = (prId: any) => {
    setGallerModal(true);
    setProId(prId);
  };

  const openBuyerModel = (proId: any) => {
    setBuyerModel(true);
    //alert(proId);
    setProductId(proId);
  };

  console.log(downloadproductList);

  return (
    <WebLayout pageName={"ProductList"}>
      <div className="content-wrapper">
        {buyerModel && (
          <BuyerListModel
            buyerModel={buyerModel}
            setBuyerModel={setBuyerModel}
            productId={productId}
          />
        )}
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center pb-2">
              <h4 className="card-title">Product List</h4>
              <div>
                <Link to="/add-product" className="btn btn-primary">
                  Add New Product
                </Link>
              </div>
            </div>
            <div
              className="row g-3 px-4 mb-2 d-flex
              justify-content-between
              align-items-end">
              <div className="col-md-3">
                <label className="mb-2">Show Entries</label>
                <select
                  className="form-select"
                  onChange={(e) => setLimit(e.target.value)}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div className="col-md-3">
                <div className="input-group input-group-merge">
                  <span className="input-group-text" id="basic-addon-search31">
                    <i className="bx bx-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="table-responsive text-nowrap">
              <table className="table text-center table-bordered">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th>Name</th>
                    <th>Product Code</th>
                    <th>Image</th>
                    <th>MRP</th>
                    <th>Ex Factory Price </th>
                    <th>Tax</th>
                    <th> Ex Factory Price </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {galleryModel && (
                    <UpdateProductImage
                      setGallerModal={setGallerModal}
                      galleryModel={galleryModel}
                      renderList={getProductList}
                      proId={proId}
                    />
                  )}
                  {productList?.length > 0 ? (
                    productList.map((proDataList: any, index: number) => (
                      <tr key={proDataList.id}>
                        <td>{from + index}</td>
                        <td>{proDataList.product_name}</td>
                        <td>{proDataList.product_code}</td>
                        <td>
                          {proDataList.proId == null ? (
                            <button
                              style={{ marginRight: "20px" }}
                              onClick={() => openModel(proDataList.id)}
                              className="btn btn-sm btn-success">
                              Add Image
                            </button>
                          ) : (
                            <img
                              src={proDataList.proImage}
                              alt={proDataList.product_name}
                              width={70}></img>
                          )}
                        </td>
                        <td colSpan={proDataList.is_variant === "YES" ? 2 : 0}>
                          {proDataList.is_variant === "YES" ? (
                            <Link
                              to={`/add-variant/${proDataList.id}`}
                              className="btn btn-sm btn-success">
                              Add Variants
                            </Link>
                          ) : (
                            proDataList.mrp.toFixed(2)
                          )}
                        </td>
                        {proDataList.is_variant === "NO" ? (
                          <td>
                            {proDataList.landing_cost.toFixed(2)}{" "}
                            <span className="text-success">(Without Tax)</span>
                          </td>
                        ) : null}
                        <td>{proDataList.tax}</td>
                        <td>
                          {(
                            proDataList.landing_cost +
                            proDataList.seller_tax_amount
                          ).toFixed(2)}{" "}
                          <span className="text-success">(With Tax)</span>
                        </td>
                        <td>
                          <StatusSwitch
                            productId={proDataList.id}
                            statusActive={proDataList.status}
                          />
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              type="button"
                              className="btn p-0 dropdown-toggle hide-arrow"
                              data-bs-toggle="dropdown">
                              <i className="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <div className="dropdown-menu">
                              <Link
                                className="dropdown-item"
                                to={"/edit-product/" + proDataList.id}>
                                <i className="bx bx-edit-alt me-1"></i> Edit
                              </Link>
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);">
                                <i className="bx bx-trash me-1"></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10}>No matching records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {productList?.length > 0 ? (
              <div className="demo-inline-spacing px-4 m-auto">
                <h6 className={"text-center"}>
                  Showing {from} to {to} of {totalData} entries
                </h6>
                <nav aria-label="Page navigation">
                  <ul className="pagination pagination-round pagination-primary">
                    <li className="page-item first" onClick={() => setPage(1)}>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevrons-left"></i>
                      </a>
                    </li>
                    <li
                      className={`page-item prev ${
                        page === 1 ? "disabled" : ""
                      }`}
                      onClick={() =>
                        page === 1 ? "" : setPage(currentPage - 1)
                      }>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevron-left"></i>
                      </a>
                    </li>

                    {pagination.map((p) => {
                      return (
                        <li
                          className={`page-item ${
                            currentPage === p ? "active" : ""
                          }`}
                          onClick={() => setPage(p)}>
                          <a className="page-link" href="javascript:void(0);">
                            {p}
                          </a>
                        </li>
                      );
                    })}

                    <li
                      className={`page-item next ${
                        lastPage === page ? "disabled" : ""
                      }`}
                      onClick={() =>
                        lastPage === page ? "" : setPage(currentPage + 1)
                      }>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevron-right"></i>
                      </a>
                    </li>
                    <li
                      className="page-item last"
                      onClick={() => setPage(lastPage)}>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevrons-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default ProductList;
